import * as React from 'react';
import useStyles from './ForgotUsernamePasswordForm.styles';

import { Trans } from '@lingui/react';
import { Auth0SelectButton } from '../../atoms/Auth0SelectButton';

const ForgotUsernamePasswordForm: React.FC = () => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Auth0SelectButton
        buttonText={<Trans id="Forgot Username" />}
        onClick={() => (window.location.href = '/ciam/forgot-username')}
      />
      <Auth0SelectButton
        buttonText={<Trans id="Forgot Password" />}
        onClick={() => (window.location.href = '/ciam/forgot-password')}
      />
    </div>
  );
};

export default ForgotUsernamePasswordForm;
